import { EditableClientProps } from '@/shared/types/editable';

export const parseProps = (json: string): EditableClientProps => {
  const jsonDateReviver = (key: string, value: string) => {
    const date = new Date(value);
    return !Number.isNaN(date.valueOf()) && date.toISOString() === value ? date : value;
  };

  return JSON.parse(json, jsonDateReviver);
};

export const addKeydownListener = (element: HTMLElement) => {
  // Listen for keydown as change event fires after dependent events
  element.addEventListener('keydown', (e: any) => {
    if (e.key !== 'Escape' && e.key !== 'Tab') {
      change(element)();
    }
  });
};

export const change = (element: HTMLElement) => () => {
  const form = element.closest('form');

  if (form) {
    form.dataset.dirty = 'true';
  }
};
